/**
 * QUIOSQUE — as contas dos TERMINAIS de chão (/bancada e /coletor).
 *
 * Uma conta de terminal é reconhecida pela PERMISSÃO, nunca por e-mail: só
 * `wms:operate` mais o piso que o backend deriva para TODA conta
 * (`profile:read`/`profile:write`, ver backend_v2 core/middlewares/auth.js).
 * Qualquer chave a mais (inclusive o god-mode `admin`/`developer`/`*`) já faz
 * dela uma conta de mesa, e a trava não se aplica.
 */

/** A permissão que faz de uma conta um terminal de chão. */
export const KIOSK_OPERATE_PERMISSION = 'wms:operate';

/** Tudo o que uma conta de terminal pode ter; uma chave fora daqui a tira do quiosque. */
export const KIOSK_ACCOUNT_PERMISSIONS = Object.freeze([KIOSK_OPERATE_PERMISSION, 'profile:read', 'profile:write']);

/** Rota da bancada (monitor 1280×1024 das bancadas). */
export const KIOSK_BENCH_PATH = '/bancada';

/** Rota do coletor (Android de mão). */
export const KIOSK_COLLECTOR_PATH = '/coletor';

/** Largura a partir da qual o terminal é bancada; abaixo dela é coletor. */
export const KIOSK_BENCH_MIN_WIDTH = 1024;

/**
 * Flag de TELA CHEIA da bancada, por navegador. Nasce '1' na primeira vez que a
 * estação de /bancada abre e, dali em diante, toda interação (bipe, clique)
 * em /bancada devolve a tela cheia. Não existe botão para desligar: o
 * supervisor desliga pelo devtools com
 *   localStorage.setItem('wms.bancada.telaCheia', '0')
 * ('0' é respeitado para sempre; APAGAR a chave religa na próxima abertura).
 */
export const KIOSK_FULLSCREEN_STORAGE_KEY = 'wms.bancada.telaCheia';

/** Elementos marcados com este atributo não devolvem a tela cheia (ex.: o botão Melidash). */
export const KIOSK_FULLSCREEN_OPT_OUT_ATTRIBUTE = 'data-sem-tela-cheia';
